export const SHAREDMAPS_COLLECTION = 'sharedMaps';
export const FEATURES_COLLECTION = 'features';
export const TAX_FEATURES_COLLECTION = 'taxFeatures';
export const OVERLAY_COLLECTION = 'beyondMaps-overlay';
